/**
 * 画面の名前。
 *
 * <b>1か所に置く。</b>ルータの登録・右上のメニュー・案内の文が
 * それぞれ同じ文字列を直に持っていた。名前を変えると、ルータだけ
 * 変わって案内は古いまま、が黙って起きる。
 *
 * 実際に起きた。会社設定のGoogle連携の説明が「個人設定から」と
 * 案内していたが、その設定は個人設定には無い。開いた管理者は右上から
 * 個人設定を選び、何も見つけられなかった。
 */

/** 本人のログイン方法をまとめた画面。 */
export const SECURITY_SCREEN_NAME = 'ログインとセキュリティ'

/** 本人の連絡先や表示名をまとめた画面。 */
export const PERSONAL_SCREEN_NAME = '個人設定'
